module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmuskel3-8d212f6e7cba3e30695bcead90efa402.jpg";